import React, { useEffect, useState } from 'react';
import { StyleSheet, View, FlatList, TouchableWithoutFeedback, TouchableOpacity, Alert } from 'react-native';
import { Text, Button, Snackbar } from 'react-native-paper';
import { useNavigation } from '@react-navigation/native';
import Fondo from '../modules/component/Fondo';
import { FontAwesome5, MaterialIcons } from '@expo/vector-icons';
import ButtonGradient from '../modules/component/ButtonGradient';
import * as Location from 'expo-location';
import theme from './../../lib/theme.js';
import CustomModal from './CustomModal';
import { apiFetch } from '../modules/api';

const IncidenciasUPC = (props) => {
  const { data, upc } = props.route.params;
  const navigation = useNavigation();

  const [errorMsg, setErrorMsg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [incidenciaUPC, setIncidenciaUPC] = useState([]);
  const [UPCActual, setUPCActual] = useState({});
  const [incidenciaATerminar, setIncidenciaATerminar] = useState({});
  const [modalVisible, setModalVisible] = useState(false);
  const [snackBarVisible, setSnackBarVisble] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const showAlert = () =>

    Alert.alert(gMsg, [
      {
        text: "Aceptar",
        onPress: () => navigation.goBack()
      }
    ],
      { cancelable: true });


  async function validarGpsEncendido() {

    let { status } = await Location.requestForegroundPermissionsAsync();

    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
      showAlert();
      navigation.navigate("Acceso");
      return;
    } else {
      let location = await Location.watchPositionAsync(
        {
          accuracy: Location.Accuracy.High,
          timeInterval: 5000,
          distanceInterval: 10
        },
        (loc) => {
          gGeo = loc.coords;
        }
      );
    }
  }

  async function guardarInc(id) {
    if(isSaving){
      return;
    }
    setIsSaving(true);
    try {
      var altitude = gGeo.altitude
      var latitude = gGeo.latitude
      var longitude = gGeo.longitude
    } catch {

      validarGpsEncendido();

    }
    var incidenciasTrue = "";
    var incidenciasFalse = "";


    var datos = '{"incidencias_true" : "' + id + '","incidencias_false" : "" }'

    var requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    };
    
    const response = await apiFetch(gApiPath + "/api/guardarEstatusIncidencia", requestOptions);
    const json = await response.json();

    if (json.estatus == "bien") {
      const arregloNuevo = incidenciaUPC.filter(item => item.id !== id);
      setIncidenciaUPC(arregloNuevo);
    }else{
      gMsg = 'Ocurrió un problema al actualizar la incidencia, intentalo de nuevo mas tarde.'
      showAlert();
    }
    setIsSaving(false);
    setSnackBarVisble(true);
    setModalVisible(false);
  }


  useEffect(function () {
    let mounted = true;
    (async () => {
      let { status } = await Location.requestForegroundPermissionsAsync();
      if (status !== 'granted') {
        setErrorMsg('Permission to access location was denied');
        navigation.navigate("Acceso");
        return;
      }
      return () => mounted = false;
    })();

    async function fetchData() {

      if (mounted) {
        const upcFiltrado = data.filter((incidencia) => incidencia.upc === upc);
        if (upcFiltrado.length > 0) {
          setUPCActual(upcFiltrado[0]);
        }
        setIncidenciaUPC(upcFiltrado);
        setIsLoading(false);
        gCheckboxSeg = {};
      }

    }


    fetchData();
    return () => mounted = false;

  }, []);

  const Spacer = ({ height = 16 }) => <View style={{ height }} />;

  const handleTerminarIncidencia = (item) => {
    setIncidenciaATerminar(item);
    setModalVisible(true);
  }

  const ModalContent = (props) => {
    const { incidencia, setModalVisible, guardarInc, isSaving } = props;

    const styles = StyleSheet.create({
      textStyle: {
        color: 'white',
        fontWeight: 'bold',
        textAlign: 'center',
      },
      modalText: {
        marginBottom: 15,
        textAlign: 'center',
      },
    });
    return (
      <View>
        <Text style={theme.modalText}>La incidencia <Text style={{...theme.modalText, fontWeight:'bold'}}>{incidencia.tipo_incidencia}</Text> se marcará como <Text style={{...theme.modalText, fontWeight:'bold'}}>resuelta</Text> y esta acción no se puede revertir.</Text>
        <Text style={{...theme.modalText, fontWeight:'bold', textAlign: 'center'}}>¿Deseas continuar?</Text>
        <TouchableWithoutFeedback onPress={() => guardarInc(incidencia.id)}>
          <Button onPress={() => guardarInc(incidencia.id)} disabled={isSaving} loading={isSaving} mode="contained" style={{ marginTop: 20, marginBottom: 10 }}>
            {!isSaving ? 'Marcar como resuelta' : ''}
          </Button>
        </TouchableWithoutFeedback>
        <TouchableWithoutFeedback >
          <Button onPress={() => setModalVisible(false)} disabled={isSaving} mode="contained" style={isSaving ? {} : theme.buttons.error}>
            Cancelar
          </Button>
        </TouchableWithoutFeedback>
      </View>
    )
  }

  return (
    <View style={{ flex: 1, width: '100%', alignItems: 'center' }}>
      <Snackbar
        visible={snackBarVisible}
        style={{ zIndex: 2 }}
        duration={3000}
        onDismiss={() => setSnackBarVisble(false)}
        action={{
          label: 'Cerrar',
          onPress: () => {
            setSnackBarVisble(false)
          },
        }}>
        La incidencia se marcó como resuelta correctamente
      </Snackbar>
      <Fondo />
      <CustomModal modalVisible={modalVisible} setModalVisible={setModalVisible} incidencia={incidenciaATerminar} guardarInc={guardarInc} Content={ModalContent} isSaving={isSaving} />
      <View style={{ width: "100%",  height: "120px" , maxHeight: 130 }} >
        <View
          style={{
            ...theme.cards, backgroundColor: "#fff",
            flexWrap: 'wrap', flex: 1, height: 110, maxHeight: 130, justifyContent: "center"
          }}>
          <View style={{ alignItems: 'center', justifyContent: "center", height: "100%", marginRight: 10 }}>
            <MaterialIcons style={{ textAlign: 'center' }} name="local-grocery-store" size={50} color="#333" />
          </View>
          <View style={{ whiteSpace: "nowrap", maxWidth: 300 }}>
            <Text style={{ ...theme.subTitle, fontWeight: 'bold' }} ellipsizeMode="tail" numberOfLines={2}>UPC: {UPCActual.upc}</Text>
            <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>{UPCActual.descripcion}</Text>
          </View>
        </View>
      </View>
      {!isLoading && incidenciaUPC.length > 0 ?
        <FlatList
          style={{ flex: 1, aignItems: 'center', width: '100%', maxHeight: "75vh", zIndex:-1 }}
          data={incidenciaUPC}
          keyExtractor={item => item.id}
          renderItem={({ item }) =>
            <View style={{ flex: 1, aignItems: 'center', width: '100%', shadowOpacity: 0, elevation: 0 }}>
              <TouchableOpacity style={{ ...theme.cards, backgroundColor: theme.colors.danger, flexWrap: 'wrap', flex: 1, height: 110, maxHeight: 130, justifyContent: "center" }} onPress={() => handleTerminarIncidencia(item)}>
                <View style={{ justifyContent: "center", height: "100%" }}>
                  <FontAwesome5 style={{ textAlign: 'center' }} name="tasks" size={35} color="#fff" />
                </View>
                <View style={{ marginLeft: 15, whiteSpace: "nowrap", maxWidth: 300 }}>
                  <Text style={theme.storeCardTitle} >{item.tipo_incidencia}</Text>
                  <Text style={theme.storeCardText} >Fecha del incidente: {item.fecha_ansi.substring(8, 10)}/{item.fecha_ansi.substring(5, 7)}/{item.fecha_ansi.substring(0, 4)}</Text>
                </View>
              </TouchableOpacity>
            </View>}
        /> : null}
      {isLoading && (
       <Text>Cargando...</Text>
      )}
      {!isLoading && incidenciaUPC.length === 0 && 
       <View style={{ flex: 1, aignItems: 'center'}}>
         <MaterialIcons name="check-circle" style={{ textAlign: 'center' }} size={100} color={theme.colors.success} />
         <Text style={theme.subTitle2} ellipsizeMode="tail" numberOfLines={3}>No quedan incidencias para este UPC</Text>
      </View>}
    </View>
  );
}

export default IncidenciasUPC

const styles = StyleSheet.create({

  titulo: {
    fontSize: 25,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  }, text: {
    fontSize: 13,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase'
  },
  titulo1: {
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    marginTop: 20,
  },

  titulo2: {
    fontSize: 25,
    paddingLeft: 45,
    color: "black",
    fontWeight: 'bold',
    marginTop: 10


  },

  titulo3: {
    fontSize: 15,
    color: "white",
    fontWeight: 'bold',
    marginRight: 30,
    textAlign: 'center'
  },

  titulo4: {
    fontSize: 20,
    color: "white",
    fontWeight: 'bold',
    marginRight: 30,
    textAlign: 'center'
  },
  button: {

    padding: 15,
    width: '100%',
    height: '90%',
    borderRadius: 20,
    fontWeight: 'bold',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 2,
    marginBottom: 2,
    marginRight: 12

  },
  container2: {
    flex: 1,
    marginTop: 10,
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',

  }, checkboxBase: {
    width: 44,
    height: 44,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    borderWidth: 2,
    borderColor: 'coral',
    backgroundColor: 'transparent',
  }, container5: {
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 20,
    width: '80%'
  },

  checkboxChecked: {
    backgroundColor: 'coral',
  },

  checkboxContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 20,
    width: '90%'

  },
  TableText: {
    fontSize: 13,
    margin: 10,
    textAlign: 'center',
    color: "white",
    fontWeight: 'bold'
  },
  textTable: {

    fontSize: 20,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: "black",
    textAlign: 'center',
    width: "98%",
    marginTop: 20

  }


});


